<template><!--用户协议-->
  <div class="user">

    <div style="text-align: center; margin: 20px 0;">
      <h2>用户协议</h2>
    </div>

    <div class="userMain">
      <h3>特别提示</h3>
      本协议约定陌撩与用户之间关于“陌撩漂流瓶”软件服务（以下简称“服务”）的权利义务。“用户”是指下载、安装、注册、登录、使用（以下统称“使用”）本服务的个人。睢宁陌撩信息科技有限公司（以下简称“陌撩”）在此特别提醒您（用户）在注册成为用户之前，请认真阅读本《用户协议》（以下简称“协议”），确保您充分理解本协议中各条款。请您审慎阅读并充分理解本协议，特别是涉及免除或者限制责任的条款、权利许可和信息使用的条款、同意开通和使用特殊单项服务的条款、法律适用和争议解决条款等。其中，免除或者限制责任条款等重要内容将以加粗形式提示用户注意，您应重点阅读。如您不同意本协议，这将导致陌撩无法为您提供完整的产品和服务，您也可以选择停止使用。如您自主选择同意或使用陌撩漂流瓶及相关服务，则视为您已充分理解本协议，并同意作为本协议的一方当事人接受本协议以及其他与陌撩漂流瓶及相关服务相关的协议和规则（包括但不限于
      《陌撩漂流瓶隐私政策》）的约束。
      <br>
      为给用户提供更好的服务或因国家法律法规、政策调整、技术条件、产品功能等变化需要，本协议可由陌撩适时修订更新，修订的内容构成本协议的组成部分。本协议更新后，陌撩会通过官方网站公告或其他适当的方式提醒用户更新的内容，以便用户及时了解本协议的最新版本，用户也可以在网站首页或软件设置页面查阅最新版本的协议条款。如用户继续使用“陌撩漂流瓶”软件及相关服务，即表示用户已同意接受修订后的本协议内容。
      请您充分理解并同意，本平台禁止未成年人用户注册及使用相关服务，如您属于未满18周岁的中国公民或所属国规定的未成年人，您将无法注册本产品。出于用户管理及未成年人保护之目的，依据相关规定，我们会基于未成年保护相关机制对未成年进行识别，判断您的行为，如平台判定您的账号具有未成年使用风险，我们将为您提供青少年保护服务模式，具体内容和限制以青少年模式实际页面展示为准。
      <h3>一、账号注册</h3>
      <div>
        <p>
          1、为了能使用本服务，您需要注册陌撩漂流瓶账号，应当使用手机号码绑定注册，请用户使用尚未与陌撩漂流瓶账号绑定的手机号码，以及未被陌撩根据本协议封禁的手机号码注册“陌撩漂流瓶”账号。陌撩可以根据用户需求或产品需要对账号注册和绑定的方式进行变更。
        </p>
        <p>
          2、“陌撩漂流瓶”系基于地理位置的移动社交产品，用户注册时可授权陌撩公开及使用其地理位置信息。
        </p>
        <p>
          3、鉴于陌撩漂流瓶账号的注册方式，且为了保护您账号的安全，您同意陌撩在注册时使用用户提供的手机号码及/或自动提取用户的手机号码及自动提取的用户的手机设备识别码等信息用于注册。用户同意给予运营商授权，授权运营商有权自动提取用户的手机号码进行认证并用于“陌撩漂流瓶”账号注册，用户保证遵守运营商的相关服务条款，如运营商对用户的手机号认证成功，则用户的注册即完成。如用户不同意对运营商的授权和/或服务条款或者是用户的手机号认证失败，用户可以手动修改运营商提取的手机号码，采取验证码方式进行注册登录。
        </p>
        <b>
          4、用户理解并承诺，用户所设置的账号不得违反国家法律法规及陌撩漂流瓶的相关规则，用户的账号名称、头像和简介等注册信息及其他个人信息中不得出现违法和不良信息，未经他人许可不得用他人名义（包括但不限于冒用他人姓名、名称、字号、头像等或采取其他足以让人引起混淆的方式）开设账号，不得恶意注册陌撩漂流瓶账号（包括但不限于频繁注册、批量注册账号等行为）。用户在账号注册及使用过程中需遵守相关法律法规，不得实施任何侵害国家利益、损害其他公民合法权益，有害社会道德风尚的行为。陌撩有权对用户提交的注册信息进行审核。
        </b>
        <p>
          5、在用户注册及使用本服务时，陌撩需要收集能识别用户身份的个人信息以便陌撩可以在必要时联系用户，或为用户提供更好的使用体验。陌撩收集的信息包括但不限于用户的姓名、性别、年龄、出生日期、身份证号、地址、学校情况、公司情况、所属行业、兴趣爱好、常出没的地方、个人说明；陌撩对这些信息的使用将受限于第四条用户个人隐私信息保护的约束。
        </p>
      </div>

      <h3>二、账号管理</h3>
      <div>
        <b>
          1、“陌撩漂流瓶”账号的所有权归陌撩所有，用户完成申请注册手续后，获得“陌撩漂流瓶”账号的使用权，该使用权仅属于初始申请注册人，初始申请注册人不得赠与、借用、租用、转让或售卖“陌撩漂流瓶”账号或者以其他方式许可非初始申请注册人使用“陌撩漂流瓶”账号。非初始申请注册人不得通过受赠、继承、承租、受让或者其他任何方式使用“陌撩漂流瓶”账号。如果陌撩发现或者有合理理由认为使用者并非账号初始注册人，为保障账号安全，陌撩有权立即暂停或终止向该注册账号提供服务，并有权永久禁用该账号。
        </b>
        <p>
          2、用户可以通过1）查看与编辑个人资料页，2）“设置”页面里的“账号与安全”页面来查询、更改、删除、注销“陌撩漂流瓶”账户上的个人资料、部分可更改的注册信息及传送内容等，但需注意，删除有关信息的同时也会删除用户储存在系统中的文字和图片。
        </p>
        <p>
          3、用户有责任妥善保管注册账号信息及账号密码的安全，因用户保管不善可能导致遭受盗号或密码失窃、遭到未获授权的使用，或者发生其它任何安全问题时，责任由用户自行承担。用户需要对注册账号以及密码下的行为承担法律责任。用户同意在任何情况下不使用其他用户的账号或密码。在用户怀疑他人使用其账号或密码时，用户同意立即通知陌撩。
        </p>
        <p>
          4、用户应遵守本协议的各项条款，正确、适当地使用本服务，如因用户违反本协议中的任何条款，陌撩在通知用户后有权依据协议中断或终止对违约用户“陌撩漂流瓶”账号提供服务。
        </p>
        <p>
          5、用户可以通过“设置”页面里的“账号与安全”页面来进行账号注销服务，陌撩会在完成个人身份、安全状态、设备信息、侵权投诉等方面的合理和必要的验证后协助用户注销账号，并依照用户的要求删除有关用户账号的一切信息，法律法规另有规定的除外。用户确认注销账号是不可恢复的操作，用户应自行备份与陌撩漂流瓶账号相关的信息和数据，用户确认操作之前与陌撩漂流瓶账号相关的所有服务均已进行妥善处理。用户确认并同意注销账号后并不代表本陌撩漂流瓶账号注销前的账号行为和相关责任得到豁免或减轻，如在注销期间，用户的账号被他人投诉、被国家机关调查或者正处于诉讼、仲裁程序中，陌撩有权自行终止用户的账号注销。
        </p>
      </div>

      <h3>三、服务内容</h3>
      <div>
        <p>
          1、本服务的具体内容由陌撩根据实际情况提供，包括但不限于授权用户通过其账号进行即时通讯、添加好友、发布留言、互动交流。为更好的提升用户体验及服务，陌撩将不定期变更其提供的服务（包括但不限于软件修改、升级、功能强化、开发新服务、软件替换等）；用户将会收到陌撩关于服务变更的通知（包括但不限于系统提示、公告、站内信等）。用户有权选择接受更新后版本；如用户选择不作更新，则本服务的部分功能将受到限制或不能正常使用。
        </p>
        <p>
          2、陌撩许可用户一项个人的、可撤销的、不可转让的、非独占地和非商业的合法使用陌撩漂流瓶及相关服务的权利。本协议未明示授权的其他一切权利仍由陌撩保留，用户在行使该些权利前须另行获得陌撩的书面许可，同时陌撩如未行使前述任何权利，并不构成对该权利的放弃。
        </p>
        <p>
          3、陌撩提供的服务包含免费服务与收费服务。用户可以通过付费方式购买收费服务，具体方式为：用户通过“陌撩漂流瓶”平台提供的付费途径支付一定数额的人民币购买“陌撩漂流瓶”平台的虚拟货币——陌撩币，然后根据陌撩公布的资费标准以陌撩币购买用户欲使用的收费服务，从而获得收费服务使用权限。对于收费服务，陌撩会在用户使用之前给予用户明确的提示，只有用户根据提示确认其同意按照前述支付方式支付费用并完成了支付行为，用户才能使用该等收费服务。支付行为的完成以支付渠道生成“支付已完成”的确认通知为准。
        </p>
        <p>
          4、用户购买陌撩漂流瓶付费功能要求开具发票的，陌撩漂流瓶负责开具用户提出要求当年的增值税普通发票，增值税由用户承担；如产生运输费、快递费等由用户承担。
        </p>
      </div>

      <h3>四、用户个人信息保护</h3>
      <div>
        <p>
          1、用户在注册账号或使用本服务的过程中，可能需要填写并提交一些必要的个人信息，如法律法规、规章规范性文件（以下称“法律法规”）规定的需要填写的身份信息。如用户填写、提交的信息不完整或不符合法律法规的规定，则用户可能无法使用本服务或在使用本服务的过程中受到限制。
        </p>
        <p>
          2、用户个人信息包括：
          <br> ●1）用户自行提供的用户个人信息（如注册时填写的手机号码等个人信息，用户开启定位功能并使用服务时的地理位置信息等）；
          <br> ●2）其他方共享的用户个人信息；
          <br> ●3）陌撩为提供服务而合法收集的用户必要个人信息（如使用服务时系统自动采集的设备或软件信息，浏览历史信息，时间信息等信息）。
          其中个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。用户知悉、理解并同意，用户在使用陌撩的产品与/或服务时，陌撩将按照平台公布的《陌撩漂流瓶隐私政策》的约定处理和保护用户的个人信息，因此希望用户能够仔细阅读、充分理解《陌撩漂流瓶隐私政策》的全文，并在需要时，按照《陌撩漂流瓶隐私政策》的指引，作出用户认为适当的选择。
        </p>
        <p>
          3、陌撩重视对个人信息的保护，陌撩将采取技术措施和其他必要措施，确保用户个人信息安全，防止在本服务中收集的用户个人信息泄露、毁损或丢失。在发生前述情形或者陌撩发现存在发生前述情形的可能时，陌撩将及时采取补救措施并告知用户，用户如发现存在前述情形亦需立即与陌撩联系。
        </p>
        <p>
          4、陌撩未经用户同意不向任何第三方公开、 透露用户个人信息。但以下特定情形除外：
          <br> ●(1) 陌撩根据法律法规规定或有权机关的指示提供用户的个人信息；
          <br> ●(2) 由于用户将其用户密码告知他人或与他人共享注册账户与密码，由此导致的任何个人信息的泄露，或其他非因陌撩原因导致的个人信息的泄露；
          <br> ●(3) 用户自行向第三方公开其个人信息；
          <br> ●(4) 用户与陌撩及合作单位之间就用户个人信息的使用公开达成约定，陌撩因此向合作单位公开用户个人信息；
          <br> ●(5) 任何由于黑客攻击、电脑病毒侵入及其他不可抗力事件导致用户个人信息的泄露；
          <br> ●(6) 用户个人信息已经经过处理无法识别特定个人且不能复原。
        </p>
        <p>5、用户同意陌撩可在以下事项中使用用户的个人信息：
          <br> ●(1) 陌撩向用户及时发送重要通知，如软件更新、本协议条款的变更；
          <br> ●(2) 陌撩内部进行审计、数据分析和研究等，以改进陌撩的产品、服务和与用户之间的沟通；
          <br> ●(3) 依本协议约定，陌撩管理、审查用户信息及进行处理措施；
          <br> ●(4) 适用法律法规规定的其他事项。
          <br> 除上述事项外，如未取得用户事先同意，陌撩不会将用户个人信息使用于任何其他用途。
        </p>
        <p>
          6、陌撩重视对未成年人的保护。任何18岁以下的未成年人均不得注册账号或使用本服务。
        </p>
        <p>
          7、陌撩保证在合法、正当与必要的原则下收集、使用或者公开用户个人信息且不会收集与提供的服务无关的用户个人信息。
        </p>
        <p>
          8、陌撩十分注重保护用户的个人信息及个人隐私，并制定了《陌撩漂流瓶隐私政策》，用户应当在仔细阅读、充分理解《陌撩漂流瓶隐私政策》后使用陌撩的产品与/或服务，如果用户不同意政策的内容，将可能导致陌撩的产品与/或服务无法正常运行，或者无法达到陌撩拟达到的服务效果。用户亦可以通过“我的-右上角-关于陌撩漂流瓶”来进行具体查看，陌撩希望通过《陌撩漂流瓶隐私政策》向用户清楚地介绍对用户个人信息的处理方式，因此建议用户完整地阅读《陌撩漂流瓶隐私政策》，以帮助用户更好地保护用户的隐私权。
        </p>
      </div>

      <h3>五、内容规范</h3>
      <div>
        <p>
          1、本条所述内容是指用户使用本服务过程中所制作、上传、复制、发布、传播的任何内容，包括但不限于账号头像、名称、用户说明等注册信息及认证资料，或文字、语音、图片、视频、图文等发送、回复或自动回复消息和相关链接页面，以及其他使用账号或本服务所产生的内容。
        </p>
        <p>
          2、用户不得利用“陌撩漂流瓶”账号或本服务制作、上传、复制、发布、传播如下法律、法规和政策禁止的内容：
          <br> ●(1) 反对宪法所确定的基本原则的；
          <br> ●(2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
          <br> ●(3) 损害国家荣誉和利益的；
          <br> ●(4) 歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；
          <br> ●(5) 宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；
          <br> ●(6) 煽动民族仇恨、民族歧视，破坏民族团结的；
          <br> ●(7) 破坏国家宗教政策，宣扬邪教和封建迷信的；
          <br> ●(8) 散布谣言，扰乱经济秩序和社会秩序的；
          <br> ●(9) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
          <br> ●(10) 侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；
          <br> ●(11) 煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；
          <br> ●(12) 以非法民间组织名义活动的；
          <br> ●(13) 不遵守法律法规底线、社会主义制度底线、国家利益底线、公民合法权益底线、社会公共秩序底线、道德风尚底线和信息真实性底线的“七条底线”要求的；
          <br> ●(14) 含有法律、行政法规、政策禁止的其他内容的信息。
        </p>
        <p>
          3、用户不得利用“陌撩漂流瓶”账号或本服务制作、上传、复制、发布、传播如下干扰“陌撩漂流瓶”正常运营，以及侵犯其他用户或第三方合法权益，对网络生态造成不良影响的内容：
          <br> ●(1) 使用夸张标题，内容与标题严重不符的；
          <br> ●(2) 炒作绯闻、丑闻、劣迹等的；
          <br> ●(3) 不当评述自然灾害、重大事故等灾难的；
          <br> ●(4) 带有性暗示、性挑逗等易使人产生性联想的；
          <br> ●(5) 展现血腥、惊悚、残忍等致人身心不适的；
          <br> ●(6) 煽动人群歧视、地域歧视等的；
          <br> ●(7) 宣扬低俗、庸俗、媚俗内容的；
          <br> ●(8) 可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；
          <br> ●(9) 含有辱骂、恐吓、威胁内容的；
          <br> ●(10) 含有骚扰、垃圾广告、恶意信息、诱骗信息的；
          <br> ●(11) 侵害他人个人信息或资料的；
          <br> ●(12) 侵害他人肖像权、知识产权、商业秘密等合法权利的；
          <br> ●(13) 含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益内容，对网络生态造成不良影响的信息。
        </p>
      </div>

      <h3>六、使用规则</h3>
      <div>
        <p>
          1、用户在本服务中或通过本服务所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表陌撩的观点、立场或政策，陌撩对此不承担任何责任。
        </p>
        <p>
          2、用户不得利用“陌撩漂流瓶”账号或本服务进行如下行为：
          <br> ●(1) 提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义的；
          <br> ●(2) 强制、诱导其他用户关注、点击链接页面或分享信息的；
          <br> ●(3) 虚构事实、隐瞒真相以误导、欺骗他人的；
          <br> ●(4) 利用技术或其他手段实施批量注册、操纵虚假账号，非法交易账号，伪造、虚构业务数据信息等破坏平台运营秩序的；
          <br> ●(5) 利用“陌撩漂流瓶”账号或本服务从事任何违法犯罪活动的；
          <br> ●(6) 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；
          <br> ●(7) 涉及流量造假、黑公关、网络水军等行为；
          <br> ●(8) 其他违反法律法规规定、侵犯其他用户合法权益、干扰“陌撩漂流瓶”正常运营或陌撩未明示授权的行为。
        </p>
        <p>
          3、用户须对利用“陌撩漂流瓶”账号或本服务传送信息的真实性、合法性、无害性、准确性、有效性等全权负责，与用户所传播的信息相关的任何法律责任由用户自行承担，与陌撩无关。如因此给陌撩或第三方造成损害的，用户应当依法予以赔偿。
        </p>
        <p>
          4、除非陌撩书面许可，用户不得从事下列任一行为：
          <br> ●(1) 删除软件及其副本上关于著作权的信息；
          <br> ●(2) 对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现软件的源代码；
          <br> ●(3) 对陌撩拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；
          <br> ●(4)
          对软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经陌撩授权的第三方工具/服务接入软件和相关系统；
          <br> ●(5) 通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；
          <br> ●(6) 通过非陌撩开发、授权的第三方软件、插件、外挂、系统，登录或使用陌撩软件及服务，或制作、发布、传播非陌撩开发、授权的第三方软件、插件、外挂、系统。
        </p>
      </div>

      <h3>七、虚拟货币</h3>
      <div>
        <p>
          1、陌撩将在“陌撩漂流瓶”平台发行虚拟货币，即陌撩币。陌撩币可用于购买“陌撩漂流瓶”平台的增值服务，包括但不限于虚拟礼物服务及会员增值服务，除此外，不得用于其他任何用途。该等增值服务的价格均以陌撩币为单位，具体价格信息将由陌撩自行决定并在相关服务页面上显示。
        </p>
        <p>
          2、陌撩币和人民币的兑换比例依用户购买渠道的不同而有不同的兑换比例，具体兑换比例以用户购买陌撩币相关渠道服务页面显示为准。陌撩有权根据运营情况随时变更上述兑换比例，并将在用户购买陌撩币相关渠道服务页面显示。
        </p>
        <p>
          3、用户默认已开通陌撩币账户，可进行陌撩币购买（下称“充值”）和消费。用户可在设置页面查询到陌撩币余额、购买记录和消费记录。陌撩币相关信息将不作为公开信息。
        </p>
        <p>
          4、用户可以通过“陌撩漂流瓶”平台提供的充值途径为陌撩币账户进行充值。用户使用陌撩币购买相关收费服务后，可将相关收费服务赠与其他用户。用户确认不会以非法方式或者使用非平台所指定的充值途径进行充值,如果用户违规使用非陌撩认可的充值途径非法充值/购买陌撩币，则陌撩不保证充值顺利或正确完成，若因此造成用户权益受损，陌撩将不会作出任何补偿或赔偿，<b>陌撩同时保留随时中止或终止用户陌撩漂流瓶账号部分或全部权限、冻结用户的账户余额、短期或永久封禁用户的账号及/或禁止用户使用各项充值服务的权利。</b>
        </p>
        <b>
          5、用户确认在进行充值前已经仔细确认过自己的账号并仔细选择及/或输入充值账号、充值金额等相关操作选项，若因用户自身输入账号错误、金额错误、操作不当或不了解充值计费方式等因素造成充错账号、充值金额错误、错选充值种类等情形而损害自身权益的，由此带来的损失由用户自行承担，陌撩将不会作出任何补偿或赔偿。
        </b>
        <b>
          6、用户同意并确认，陌撩币属于数字化产品，因其特殊属性不适用《中华人民共和国消费者权益保护法》中有关七天无理由退货条款的约束。一旦购买成功，用户账号内的陌撩币可由用户在本服务中自由使用，但陌撩不会提供任何陌撩币退款或逆向兑换服务，请用户根据自己的实际需求购买相应数量的陌撩币。
        </b>
        <b>
          7、如果陌撩发现因系统故障或其他任何原因导致的处理错误，无论有利于陌撩还是有利于用户，陌撩都有权纠正该错误。如果该措施导致用户实际收到的陌撩币数量少于用户应获得的陌撩币，则陌撩在确认该处理错误后会尽快将差额补足至用户的账户中。如果该错误导致用户实际收到的陌撩币数量多于用户应获得的陌撩币，则无论错误的性质和原因如何，陌撩有权从用户的账户中直接扣除差额。
        </b>
        <p>
          8、用户确认，陌撩币只能用于购买“陌撩漂流瓶”平台上的各类增值服务，任何情况下不得违规私下进行陌撩币交易，如违反前述约定，造成用户或第三方任何损失，陌撩不负任何责任，且如陌撩有理由怀疑用户的陌撩币账户或使用情况有作弊或异常状况，陌撩将拒绝该用户使用陌撩币进行支付，直至按本协议约定采取相关封禁措施。
        </p>
        <b>
          9、陌撩有权基于交易安全、运营策略、行业惯例等方面的考虑不时设定或修改涉及交易的相关事项，包括但不限于交易限额、交易次数等。
        </b>
        <p>
          10、为更好的向用户提供产品服务，平台会收集记录用户充值购买陌撩币并在本服务中使用陌撩币所产生的数据，包括但不限于用户充值、购买虚拟礼物等产品或服务、发红包、及其他在本服务中使用陌撩币所产生的行为信息，以及用户的账号、背包内未打赏礼物、陌撩币余额等账号信息。
        </p>
        <p>
          11、<b>因用户自身的原因导致陌撩无法提供陌撩币购买服务或提供陌撩币购买服务时发生任何错误而产生的任何损失或责任，由用户自行负责，陌撩不承担责任，</b>包括但不限于：
          <br> ●(1) 因用户的陌撩漂流瓶账号丢失、被封禁或冻结；
          <br> ●(2) 用户将密码告知他人导致的财产损失；
          <br> ●(3) 因用户绑定的第三方支付机构账户的原因导致的任何损失或责任；
          <br> ●(4) 其他用户故意或者重大过失或者违反法律法规导致的财产损失。
        </p>
        <b>
          12、用户在使用充值服务时，如出现任何涉嫌犯罪、违法违规、违反社会主义道德风尚、违反本协议或其他本服务对用户的管理规定的情形，陌撩有权视用户行为的性质及严重程度决定对用户的账号采取暂时或永久封禁措施。账号封禁后至解禁（如有）前，用户账户上剩余的陌撩币将被冻结或全部扣除，不可继续用于购买本服务提供的任何产品或服务，陌撩不予返还用户购买陌撩币时的现金价值，也不会作出任何补偿。
        </b>
        <b>
          13、用户确认并同意如用户主动注销账号，则用户已充值到账的陌撩币，购买的虚拟礼物等视为自动放弃，陌撩不予返还相应的现金价值，也不会作出任何补偿。
        </b>
        <b>
          14、用户保证用于陌撩币充值的资金均为用户的合法收入所得，且用户有充分权利按照本协议约定使用，因用户违反本条而产生的任何争议或纠纷，由用户自行处理解决，并承担由此带来的全部责任及法律后果。同时，陌撩发现（包括但不限于主动发现、收到第三方投诉或权力机关通知等情形）存在上述事由，有权单方决定限制用户使用全部或部分充值陌撩币、暂停或终止向用户提供充值服务或对用户的账号采取进一步管理措施；如因此给陌撩造成损失的，用户应予以全额赔偿，同时，陌撩有权保存相关信息，并向相关执法/司法机构、主管部门报告。
        </b>
        <p>
          15、如依据中国税收相关法律法规的规定需要由陌撩为用户代扣代缴个人所得税的，陌撩在用户产生收益的当月为用户申报并代为扣缴相关税费。
        </p>
      </div>

      <h3>八、知识产权声明</h3>
      <div>
        <p>
          1、陌撩在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权均归陌撩所有，但用户在使用本服务前对自己发布的内容已合法取得知识产权的除外。
        </p>
        <p>
          2、除另有特别声明外，陌撩提供本服务时所依托软件的著作权、专利权及其他知识产权均归陌撩所有。
        </p>
        <p>
          3、陌撩在本服务中所涉及的图形、文字或其组成，以及其他陌撩标志及产品、服务名称（以下统称“陌撩标识”），其著作权或商标权归陌撩所有。未经陌撩事先书面同意，用户不得将陌撩标识以任何方式展示或使用或作其他处理，也不得向他人表明用户有权展示、使用、或其他有权处理陌撩标识的行为。
        </p>
        <p>
          4、上述及其他任何陌撩均受到法律保护，未经陌撩书面许可，用户不得以任何形式进行使用或创造相关衍生作品。
        </p>
        <b>
          5、用户在使用陌撩漂流瓶服务时发表上传的文字、图片、视频、音频、软件、直播内容以及表演等各种形式的内容和信息均由用户原创或已获合法授权（且含转授权），此部分内容和信息的知识产权归用户或原始著作权人，责任由用户承担。用户的发表、上传行为视为对陌撩的授权，用户理解并同意授予陌撩及其关联公司全球范围内完全免费、非独家、永久、可转授权和可再许可的权利，包括但不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及《著作权法》规定的由著作权人享有的其他著作财产权利及邻接权利。陌撩可自行选择是否使用以及使用方式，包括但不限于将前述内容和信息在陌撩旗下的服务平台上使用与传播，将上述内容和信息再次编辑后使用，以及由陌撩授权给合作方使用、编辑与传播等。为避免疑义，用户理解并同意，上述授予的权利包括使用、复制和展示用户拥有或被许可使用并植入内容和信息中的个人形象、肖像、姓名、商标、服务标志、品牌、名称、标识和公司标记（如有）以及任何其他品牌、营销或推广资产、物料、素材等的权利和许可。
        </b>
      </div>

      <h3>九、国际使用之特别警告</h3>
      <div>
        您已了解国际互联网的无国界性，同意遵守当地所有关于网上行为及内容之法律法规。您特别同意遵守有关从中国或您所在国家或地区输出信息之传输的所有适用法律法规。
      </div>

      <h3>十、风险承担</h3>
      <div>
        <b>
          1、用户理解并同意，“陌撩漂流瓶”仅为用户提供信息分享、传送及获取的平台，用户必须为自己注册账号下的一切行为负责，包括用户所传送的任何内容以及由此产生的任何后果。用户应对“陌撩漂流瓶”及本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。陌撩无法且不会对因用户行为而导致的任何损失或损害承担责任。
        </b>
        <p>
          2、如果用户发现任何人违反本协议约定或以其他不当的方式使用本服务，请立即向陌撩举报或投诉，陌撩将依本协议约定进行处理。
        </p>
        <p>
          3、用户理解并同意，因业务发展需要，陌撩保留单方面对本服务的全部或部分服务内容变更、暂停、终止或撤销的权利。
        </p>
      </div>

      <h3>十一、法律责任</h3>
      <div>
        <b>
          1、如果陌撩发现或收到他人举报或投诉用户违反本协议约定的，陌撩有权对用户在平台内产生的数据（包括但不限于用户资料、动态等）进行合规审查，并视情节轻重对违规账号处以包括但不限于警告、拒绝发布、删除内容、限制账号部分或者全部功能直至终止提供服务、永久关闭账号等措施，对于因此而造成用户无法正常使用账号及相关服务、无法正常获取用户账号内资产或其他权益等后果，陌撩不承担任何责任，陌撩将通知用户处理结果，对已删除内容陌撩有权不予恢复。
        </b>
        <b>
          2、因违反用户协议被封禁的用户，在封禁期限届满后自助解封。其中，被实施功能封禁的用户会在封禁期届满后自动恢复被封禁功能。被封禁用户可向陌撩网站相关页面提交申诉，陌撩将对申诉进行审查，并自行合理判断决定是否变更处罚措施。
        </b>
        <b>
          3、用户理解并同意，陌撩有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应承担由此而产生的一切法律责任。
        </b>
        <b>
          4、用户理解并同意，因用户违反本协议约定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户应当赔偿陌撩与合作公司、关联公司，并使之免受损害。
        </b>
        <b>
          5、陌撩尊重并保护用户及他人的知识产权、名誉权、姓名权、隐私权等合法权益。用户保证，在使用本服务时上传的文字、图片、视频、音频、链接等不侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等权利及合法权益。否则，陌撩有权在收到权利方或者相关方通知的情况下移除该涉嫌侵权内容。针对第三方提出的全部权利主张，用户应自行处理并承担可能因此产生的全部法律责任；如因用户的侵权行为导致陌撩及其关联方遭受损失的（包括但不限于经济、商誉等损失），用户还应足额赔偿陌撩及其关联方遭受的全部损失。
        </b>
        <b>
          6、用户在使用陌撩提供的服务时，如出现违反国家法律法规、本协议约定或其他本平台对用户的管理规定的情形，陌撩有权暂时或永久封禁用户的账号。账号封禁后至解禁（如有）前，用户账户上的剩余陌撩币将被冻结或全部扣除，不可继续用于购买本服务提供的任何产品或服务，陌撩不予返还用户购买陌撩币时的现金价值，也不会作出任何补偿。
        </b>
      </div>

      <h3>十二、不可抗力及其他免责事由</h3>
      <div>
        <p>
          1、用户理解并确认，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为、黑客攻击、系统不稳定、第三方服务瑕疵等。出现上述情况时，陌撩将努力在第一时间与相关单位配合，及时进行修复，但是由此给用户或第三方造成的损失，陌撩及合作单位在法律允许的范围内免责。
        </p>
        <b>
          2、本服务同大多数互联网服务一样，受包括但不限于用户原因、网络服务质量、社会环境等因素的差异影响，可能受到各种安全问题的侵扰，如他人利用用户的资料，造成现实生活中的骚扰；用户下载安装的其它软件或访问的其他网站中含有“特洛伊木马”等病毒，威胁到用户的计算机信息和数据的安全，继而影响本服务的正常使用等等。用户应加强信息安全及使用者资料的保护意识，要注意加强密码保护，以免遭致损失和骚扰。
        </b>
        <b>
          3、用户理解并确认，本服务存在因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险，因此导致的用户或第三方任何损失，陌撩不承担任何责任。
        </b>
        <b>
          4、用户理解并确认，在使用本服务过程中存在来自任何他人的包括误导性的、欺骗性的、威胁性的、诽谤性的、令人反感的或非法的信息，或侵犯他人权利的匿名或冒名的信息，以及伴随该等信息的行为，因此导致的用户或第三方的任何损失，陌撩不承担任何责任。
        </b>
        <b>
          5、用户理解并确认，陌撩需要定期或不定期地对“陌撩漂流瓶”平台或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，陌撩无需为此承担任何责任，但陌撩应事先进行通告。
        </b>
        <b>
          6、陌撩依据法律法规、本协议约定获得处理违法违规或违约内容的权利，该权利不构成陌撩的义务或承诺，陌撩不能保证及时发现违法违规或违约行为或进行相应处理。
        </b>
        <b>
          7、用户理解并确认，对于陌撩向用户提供的下列产品或者服务的质量缺陷及其引发的任何损失，陌撩无需承担任何责任：
          <br> ●(1) 陌撩向用户免费提供的服务；
          <br> ●(2) 陌撩向用户赠送的任何产品或者服务。
        </b>
        <b>
          8、在任何情况下，陌撩均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因用户使用“陌撩漂流瓶”或本服务而遭受的利润损失，承担责任（即使陌撩已被告知该等损失的可能性亦然）。尽管本协议中可能含有相悖的规定，陌撩对用户承担的全部责任，无论因何原因或何种行为方式，始终不超过用户因使用陌撩提供的服务而支付给陌撩的费用(如有)。
        </b>
      </div>

      <h3>十三、服务的变更、中断、终止</h3>
      <div>
        <p>
          1、鉴于网络服务的特殊性，用户同意陌撩有权随时变更、中断或终止部分或全部的服务（包括收费服务）。陌撩变更、中断或终止的服务，陌撩应当在变更、中断或终止之前通知用户，并应向受影响的用户提供等值的替代性的服务；如用户已经购买陌撩币的但不愿意接受替代性的服务，陌撩应当按照该用户实际使用服务的情况扣除相应陌撩币之后将剩余的陌撩币退还至用户的陌撩币账户中。
        </p>
        <p>
          2、如发生下列任何一种情形，陌撩有权变更、中断或终止向用户提供的免费服务或收费服务，而无需对用户或任何第三方承担任何责任：
          <br> ●(1) 根据法律规定用户应提交真实信息，而用户提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明；
          <br> ●(2) 用户违反相关法律法规或本协议的约定；
          <br> ●(3) 按照法律规定或有权机关的要求；
          <br> ●(4) 出于安全的原因或其他必要的情形。
        </p>
      </div>

      <h3>十四、其他</h3>
      <div>
        <b>
          1、陌撩郑重提醒用户注意本协议中免除陌撩责任和限制用户权利的条款，请用户仔细阅读，自主考虑风险。
        </b>
        <b>
          2、本协议的效力、解释及纠纷的解决，适用于中华人民共和国法律。若用户和陌撩之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户同意将纠纷或争议提交陌撩住所地有管辖权的人民法院管辖。
        </b>
        <p>
          3、本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效，对双方具有约束力。
        </p>
        <p>
          4、由于互联网高速发展，用户与陌撩签署的本协议列明的条款可能并不能完整罗列并覆盖用户与陌撩漂流瓶所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，陌撩漂流瓶隐私政策、陌撩漂流瓶平台行为规范等均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如用户使用陌撩漂流瓶平台服务，视为用户同意上述补充协议。
        </p>
      </div>
    </div>

    <br>
    <br>
    <br>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
  created() {
  }
}
</script>

<style>
.user {
  width: 92%;
  max-width: 960px;
  margin: auto;
  font-size: 14px;
  line-height: 26px;
}

.user div{
  margin-bottom: 8px;
}

.user h3 {
  margin: 8px 0;
}

p {
  margin: 4px 0;
}

</style>
